import React from "react";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
function Loading(props) {
  return (
    <main>
      <div className="top-margin"></div>
      <div className="main-container user-info-container">
        <h1 className="loading-page text-center mt-5 pt-5">
          <FontAwesomeIcon icon={faSpinner} spin />
        </h1>
      </div>
    </main>
  );
}
export default Loading;
